interface TreeConnectorBoxProps {
  isLast: boolean;
  children: React.ReactNode;
}

export function TreeConnectorBox({ isLast, children }: TreeConnectorBoxProps) {
  return (
    <div data-testid="tree-connector-box" className="relative flex min-h-10">
      {/* Vertical line + horizontal branch */}
      <div className="relative w-5 shrink-0">
        {/* Vertical line: runs full height for non-last items, half for last */}
        <span
          aria-hidden="true"
          className={`absolute left-0 top-0 w-px border-l border-border-default ${
            isLast ? 'h-1/2' : 'h-full'
          }`}
        />
        {/* Horizontal branch: runs from vertical line to content */}
        <span
          aria-hidden="true"
          className="absolute left-0 top-1/2 h-px w-3.5 border-b border-border-default"
        />
      </div>
      <div className="min-w-0 flex-1">{children}</div>
    </div>
  );
}
